import {Node} from '@/models/node';
import {v4 as generateUid} from 'uuid';

const NODE_SKELETON_TEMPLATE = (node, workflow) => {
    return {
        uid: generateUid(),
        properties: {},
        children: [],
        type: 'action',
        _parentNode: node,
        _workflow: workflow
    };
};

export class NodeFactory {
    static action(node, workflow) {
        return new Node({
            ...NODE_SKELETON_TEMPLATE(node, workflow),
            type: 'action',
        });
    }

    static assign(node, workflow) {
        return new Node({
            ...NODE_SKELETON_TEMPLATE(node, workflow),
            type: 'assign',
        });
    }

    static branch(node, workflow, isDefault = false) {
        return new Node({
            ...NODE_SKELETON_TEMPLATE(node, workflow),
            type: 'branch',
            properties: {isDefault, conditions: []}
        });
    }

    static condition(node, workflow) {
        return new Node({
            ...NODE_SKELETON_TEMPLATE(node, workflow),
            type: 'condition',
            children: [
                NodeFactory.branch(node, workflow, true),
                NodeFactory.branch(node, workflow),
            ]
        });
    }

    static create(nodeType, parent, workflow) {
        return NodeFactory[nodeType](parent, workflow);
    }
}
